<template>
  <router-view v-if="!isBooting" />

  <UiLoadingIndicator
    :show="isBooting"
    class="absolute-center z-top"
  />
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import errorDialog from 'src/mixins/errorDialog';
import jwtDecode from 'jwt-decode';
import UiLoadingIndicator from 'components/ui/LoadingIndicator';

export default {
  components: { UiLoadingIndicator },
  mixins: [errorDialog],

  data() {
    return {
      renewInterval: null,
    };
  },

  computed: {
    ...mapState('application', ['isBooting', 'account', 'accessToken']),
  },

  watch: {
    // Monitor if the account is logged out/in and stop/start renew
    account(value) {
      if (value && !this.renewInterval) {
        // Check if we have an account
        this.startRenewToken();
        if (this.$route.name === 'Authentication') {
          this.$router.push({ name: 'Home' }).catch(() => {});
        }
      }

      if (value === null) {
        // Check if account has logged out
        this.stopRenewToken();
      }
    },
  },

  unmounted() {
    this.stopRenewToken();
  },

  async beforeMount() {
    try {
      await this.loadCredentials();
    }
    catch (e) {
      this.showErrorDialog(e);
    }
    finally {
      if (this.$route.meta.needsAuth && !this.account) {
        await this.$router.replace({ name: 'Authentication' }).catch(() => {});
      }
      else if (this.account) {
        await this.fetchAvailableCategories();

        // If renew check was never started we start
        if (!this.renewInterval) {
          this.startRenewToken();
        }
      }

      this.bootComplete();
    }
  },

  methods: {
    ...mapActions('auth', ['loadCredentials', 'logout', 'renewToken']),
    ...mapActions('categories', ['fetchAvailableCategories']),
    ...mapMutations('application', ['bootComplete']),

    startRenewToken() {
      this.renewInterval = setInterval(async () => {
        if (this.accessToken) {
          const decodedToken = jwtDecode(this.accessToken);
          const expires = parseInt(decodedToken.exp, 10);
          const now = parseInt(Date.now() / 1000, 10);

          // For testing expiration
          // const now = parseInt(Date.now() / 1000, 10) + (60 * 60) * 0.99;

          if (expires < now) {
            // Token is expired, lets renew
            this.stopRenewToken();
            try {
              await this.renewToken({ token: this.accessToken });
              this.startRenewToken();
            }
            catch (e) {
              await this.logout();
            }
          }
        }
      }, 5000);
    },

    stopRenewToken() {
      clearInterval(this.renewInterval);
    },
  },

};
</script>
